module.exports = __webpack_public_path__ + "media/images/favicon-7d5350f3f16da01ddfb015598f6f75bd.ico";